import { useCallback, useState } from 'react';

/** Max rows a list selection carries into one bulk request. */
export const SELECTION_CAP = 50;

/**
 * Row selection for bulk actions, cut at `cap` (one bulk request carries at
 * most that many). `capped` says the last change was cut, so the list can
 * show a notice instead of dropping rows silently.
 */
export function useCappedSelection(cap = SELECTION_CAP) {
  const [selected, setSelectedState] = useState<string[]>([]);
  const [capped, setCapped] = useState(false);

  const setSelected = useCallback(
    (keys: string[]) => {
      setCapped(keys.length > cap);
      setSelectedState(keys.slice(0, cap));
    },
    [cap]
  );

  const clear = useCallback(() => {
    setCapped(false);
    setSelectedState((prev) => (prev.length ? [] : prev));
  }, []);

  return { selected, setSelected, clear, capped };
}
